import * as v from 'valibot';
import { RpcRequestError } from '../errors/request.js';

async function handleRPCResponse(response, body, schema) {
    const json = await response.json();
    const parsed = v.safeParse(schema, json);
    if (parsed.success) {
        if (parsed.output.error !== undefined) {
            throw new RpcRequestError({
                body,
                error: parsed.output.error,
                url: response.url,
            });
        }
        return parsed.output.result;
    }
    throw new RpcRequestError({
        body,
        error: { code: -1, data: json, message: "Invalid response" },
        url: response.url,
    });
}

export { handleRPCResponse };
//# sourceMappingURL=handleRPCResponse.js.map
